import React, { useEffect, useState } from "react";
import { getSchemeBudget } from "../../helper/Api";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";
import Accordion from "react-bootstrap/Accordion";
import { useSelector } from "react-redux";

const SchemeBudgetOverlay = ({
  dividerNumber,
  overlay,
  setOverlay,
  addElipsis,
  fy_list,
  filterPayload,
}) => {
  const { authData } = useSelector((state) => state.authData);
  const storedGlobalDateId = localStorage.getItem("globalDateId");
  const [overlayDropDown, setOverlayDropDown] = useState(false);
  const [schemes, setSchemesList] = useState([]);
  const [listview, setListview] = useState(true);
  const [activeCardChild, setActiveCardChild] = useState({});
  const [maxHeight, setMaxHeight] = useState(window.innerHeight * 0.8);

  useEffect(() => {
    const handleResize = () => {
      setMaxHeight(window.innerHeight * 0.8);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleAccordion = (key) => {
    setActiveKeys(
      (prevKeys) =>
        prevKeys.includes(key)
          ? prevKeys.filter((k) => k !== key) // Remove key if it's already open
          : [...prevKeys, key] // Add key if it's closed
    );
  };
  const handleButtonClick = (cardId, buttonType) => {
    setActiveCardChild((prev) => ({
      ...prev,
      [cardId]: prev[cardId] === buttonType ? null : buttonType,
    }));
  };
  const [activeKeys, setActiveKeys] = useState([]); // Initially open accordions

  const formatNumber = (number, style = "international") => {
    number = parseFloat(number).toFixed(2); // Ensure input is a float with two decimal places
    if (style === "indian") {
      return number.replace(/\B(?=(\d{3})(\d{2})*(?!\d))/g, ",");
    } else {
      return number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  };

  const fetchSchemeBudget = async (id, departmentId) => {
    try {
      const { data } = await getSchemeBudget(id, departmentId, false);
      console.log("scheme budget data", data.result);
      setSchemesList(data.result);
    } catch (err) {
      console.log(err.name);
    }
  };

  useEffect(() => {
    if (storedGlobalDateId) {
      fetchSchemeBudget(
        storedGlobalDateId,
        filterPayload.department_id || authData?.user?.department_id
      );
    }
  }, [storedGlobalDateId, filterPayload.department_id]);

  const [tableAccordian, setTableAccordian] = useState(false);

  const toggleTableAccordion = (index) => {
    setTableAccordian((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  const [tableChildAccordian, setTableChildAccordian] = useState({});
  const toggleChildAccordion = (index) => {
    setTableChildAccordian((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const [tableSubChildAccordian, setTableSubChildAccordian] = useState({});
  const toggleSubChildAccordion = (index) => {
    setTableSubChildAccordian((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div>
      <div className={`overlay ${overlay ? "d-none" : null}  `}></div>

      <div
        className={`overlayContent overflow-auto ${
          overlay ? "left-100" : null
        } `}
        style={{ maxHeight: `${maxHeight}px` }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-secondary-100 position-relative text-white d-flex justify-content-between align-items-center ps-4 position-sticky top-0 z-200">
          <div className="fw-600 fs-16px d-flex align-items-center gap-2 z-3">
            <i
              className="icon-close_circle_fill fs-5  cursor-pointer"
              onClick={() => setOverlay(true)}
            ></i>
            Scheme Budget FY
            <select
              name="financial_year_id"
              className="bg-transparent border-0 text-white fw-500 fs-16px select"
              disabled
            >
              <option value="" className="text-black">
                select year
              </option>
              {fy_list?.map((fy) => {
                return (
                  <option
                    value={storedGlobalDateId}
                    key={fy.id}
                    className="text-black"
                    selected={
                      String(fy.id) === storedGlobalDateId ||
                      (!storedGlobalDateId &&
                        fy.start_year === moment().format("YYYY"))
                    }
                  >
                    {fy.year}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="d-flex gap-2 align-items-center h-100 py-3 position-relative pe-4">
            <span>
              As on date{" "}
              {
                <select
                  name="financial_year_id"
                  className="bg-transparent border-0 text-white fw-500 fs-16px select"
                  disabled
                >
                  <option value="" className="text-black">
                    select year
                  </option>
                  {fy_list?.map((fy) => {
                    return (
                      <option
                        value={storedGlobalDateId}
                        key={fy.id}
                        className="text-black"
                        selected={
                          String(fy.id) === storedGlobalDateId ||
                          (!storedGlobalDateId &&
                            fy.start_year === moment().format("YYYY"))
                        }
                      >
                        {fy.start_year.includes(new Date().getFullYear())
                          ? moment().format("Do MMM YYYY")
                          : "31 Mar " + fy.end_year}
                      </option>
                    );
                  })}
                </select>
              }
            </span>
            <i
              className="icon-arrow_drop_down_circle fs-18px cursor-pointer"
              onClick={() => setOverlayDropDown((prev) => !prev)}
            ></i>

            <div
              className={`position-absolute bg-prime-100 w-100 p-3 ${
                !overlayDropDown ? "d-none" : "d-inline-block"
              }`}
              style={{ top: "100%", zIndex: "10" }}
            >
              <div className="d-flex flex-column gap-4">
                <span className="d-flex align-items-center gap-2 cursor-pointer">
                  <i className="icon-featured_play_list"></i> Export Excel
                </span>
                <span className="d-flex align-items-center gap-2 cursor-pointer">
                  <i className="icon-picture_as_pdf"></i> Export PDF
                </span>
                <span
                  className="d-flex align-items-center gap-2 cursor-pointer"
                  onClick={() => setListview(false)}
                >
                  <i className="icon-view_list"></i> List View
                </span>
                <span
                  className="d-flex align-items-center gap-2 cursor-pointer"
                  onClick={() => setListview(true)}
                >
                  <i className="icon-grid_on"></i> Grid View
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="px-4 py-3 d-flex flex-column gap-2">
          {/* ==========================table view===================================== */}

          {!listview === false ? null : (
            <div className="w-100 overflow-x-auto">
              <div>
                {/* =======================heading========================= */}
                <div className="d-flex flex-wrap justify-content-start border-0 text-center">
                  <div
                    className="fw-bold border px-1"
                    style={{ flexBasis: "200px" }}
                  >
                    Scheme Code
                  </div>
                  <div
                    className="fw-bold border px-1"
                    style={{ flexBasis: "200px" }}
                  >
                    Scheme Name
                  </div>
                  <div
                    className="fw-bold border px-1"
                    style={{ flexBasis: "200px" }}
                  >
                    Provisional FY{" "}
                    {fy_list?.map((val, ind) => {
                      return val?.id == storedGlobalDateId && val?.year;
                    })}
                  </div>
                  <div
                    className="fw-bold border px-1"
                    style={{ flexBasis: "200px" }}
                  >
                    Release Fy{" "}
                    {fy_list?.map((val, ind) => {
                      return val?.id == storedGlobalDateId && val?.year;
                    })}
                  </div>
                  <div
                    className="fw-bold border px-1"
                    style={{ flexBasis: "200px" }}
                  >
                    Previous FY Balance
                  </div>
                  <div
                    className="fw-bold border px-1"
                    style={{ flexBasis: "200px" }}
                  >
                    Total Balance
                  </div>
                </div>

                {/* ===========================datas========================= */}
                {schemes?.map((val, ind) => (
                  <div
                    className="d-flex border-0  text-center flex-column position-relative overflow-hidden"
                    style={tableAccordian[ind] ? null : { height: "34px" }}
                  >
                    <div className="d-flex ">
                      <div className="border p-1" style={{ width: "20%" }}>
                        {!tableAccordian[ind] ? (
                          <i
                            className="icon-arrow_right cursor-pointer"
                            onClick={() => toggleTableAccordion(ind)}
                          ></i>
                        ) : (
                          <i
                            className="icon-arrow_drop_down cursor-pointer"
                            onClick={() => toggleTableAccordion(ind)}
                          ></i>
                        )}
                        {val?.code}
                      </div>
                      <div className="border p-1" style={{ width: "20%" }}>
                        {addElipsis(val?.name, 13)}
                      </div>
                      <div className="border p-1" style={{ width: "20%" }}>
                        {val?.total_provisional_budget == 0
                          ? "-"
                          : formatNumber(
                              val?.total_provisional_budget / dividerNumber,
                              "indian"
                            )}
                      </div>
                      <div className="border p-1" style={{ width: "20%" }}>
                        {val?.total_budget == 0
                          ? "-"
                          : formatNumber(
                              val?.total_budget / dividerNumber,
                              "indian"
                            )}
                      </div>
                      <div className="border p-1" style={{ width: "20%" }}>
                        {val?.prevYearBalance == 0
                          ? "-"
                          : formatNumber(
                              val?.prevYearBalance / dividerNumber,
                              "indian"
                            )}
                      </div>
                      <div className="border p-1" style={{ width: "20%" }}>
                        {Number(val?.total_provisional_budget) +
                          Number(val?.total_budget) +
                          Number(val?.prevYearBalance) ==
                        0
                          ? "-"
                          : formatNumber(
                              (Number(val?.total_provisional_budget) +
                                Number(val?.total_budget) +
                                Number(val?.prevYearBalance)) /
                                dividerNumber,
                              "indian"
                            )}
                      </div>
                    </div>

                    {/* ====================child datas================================== */}
                    <div
                      className=""
                      style={{
                        background: "silver",
                        height: tableChildAccordian ? null : "auto",
                      }}
                    >
                      <div className="d-flex justify-content-between text-center">
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "20%" }}
                        >
                          Sub Head
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "20%" }}
                        >
                          Provisional FY{" "}
                          {fy_list?.map((val, ind) => {
                            return val?.id == storedGlobalDateId && val?.year;
                          })}
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "20%" }}
                        >
                          Release Fy{" "}
                          {fy_list?.map((val, ind) => {
                            return val?.id == storedGlobalDateId && val?.year;
                          })}
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "20%" }}
                        >
                          Previous FY Balance
                        </div>
                        <div
                          className="fw-bold border px-1"
                          style={{ width: "20%" }}
                        >
                          Total Balance
                        </div>
                      </div>

                      {/* =========subhead data=========== */}
                      {val?.sub_head_list?.map((subHead, ind) => (
                        <div className="d-flex flex-column justify-content-between">
                          <div className="d-flex">
                            <div
                              className="border p-1"
                              style={{ width: "20%" }}
                            >
                              {!tableChildAccordian[subHead?.id] ? (
                                <i
                                  className="icon-arrow_right cursor-pointer"
                                  onClick={() =>
                                    toggleChildAccordion(subHead?.id)
                                  }
                                ></i>
                              ) : (
                                <i
                                  className="icon-arrow_drop_down cursor-pointer"
                                  onClick={() =>
                                    toggleChildAccordion(subHead?.id)
                                  }
                                ></i>
                              )}
                              {addElipsis(subHead?.name, 13)}
                            </div>
                            <div
                              className="border p-1"
                              style={{ width: "20%" }}
                            >
                              {subHead?.provisional_budget == 0 ||
                              subHead?.provisional_budget == null
                                ? "-"
                                : formatNumber(
                                    subHead?.provisional_budget / dividerNumber,
                                    "indian"
                                  )}
                            </div>
                            <div
                              className="border p-1"
                              style={{ width: "20%" }}
                            >
                              {subHead?.budget == 0 || subHead?.budget == null
                                ? "-"
                                : formatNumber(
                                    subHead?.budget / dividerNumber,
                                    "indian"
                                  )}
                            </div>
                            <div
                              className="border p-1"
                              style={{ width: "20%" }}
                            >
                              {subHead?.pervious_year_budget == 0 ||
                              subHead?.pervious_year_budget == null
                                ? "-"
                                : formatNumber(
                                    subHead?.pervious_year_budget /
                                      dividerNumber,
                                    "indian"
                                  )}
                            </div>
                            <div
                              className="border p-1"
                              style={{ width: "20%" }}
                            >
                              {Number(subHead?.budget) +
                                Number(subHead?.pervious_year_budget) ==
                              0
                                ? "-"
                                : formatNumber(
                                    (Number(subHead?.budget) +
                                      Number(subHead?.pervious_year_budget)) /
                                      dividerNumber,
                                    "indian"
                                  )}
                            </div>
                          </div>

                          {/* ===================================activity table================== */}

                          <div
                            className={`bg-success ${
                              tableChildAccordian[subHead?.id] ? "" : "d-none"
                            }`}
                            style={{
                              height: tableChildAccordian[subHead?.id]
                                ? "auto"
                                : "0",
                            }}
                          >
                            <div className="d-flex justify-content-between text-center">
                              <div
                                className="fw-bold border px-1"
                                style={{ width: "20%" }}
                              >
                                Activity
                              </div>
                              <div
                                className="fw-bold border px-1"
                                style={{ width: "20%" }}
                              >
                                Provisional FY{" "}
                                {fy_list?.map((val, ind) => {
                                  return (
                                    val?.id == storedGlobalDateId && val?.year
                                  );
                                })}
                              </div>
                              <div
                                className="fw-bold border px-1"
                                style={{ width: "20%" }}
                              >
                                Release Fy{" "}
                                {fy_list?.map((val, ind) => {
                                  return (
                                    val?.id == storedGlobalDateId && val?.year
                                  );
                                })}
                              </div>
                              <div
                                className="fw-bold border px-1"
                                style={{ width: "20%" }}
                              >
                                Previous FY Balance
                              </div>
                              <div
                                className="fw-bold border px-1"
                                style={{ width: "20%" }}
                              >
                                Total Balance
                              </div>
                            </div>

                            {/* ======data======= */}
                            {subHead?.activity_budget?.map((activity, ind) => (
                              <div className="d-flex flex-column justify-content-between">
                                <div className="d-flex">
                                  <div
                                    className="border p-1"
                                    style={{ width: "20%" }}
                                  >
                                    {!tableSubChildAccordian[
                                      activity?.activity_id
                                    ] ? (
                                      <i
                                        className="icon-arrow_right cursor-pointer"
                                        onClick={() =>
                                          toggleSubChildAccordion(
                                            activity?.activity_id
                                          )
                                        }
                                      ></i>
                                    ) : (
                                      <i
                                        className="icon-arrow_drop_down cursor-pointer"
                                        onClick={() =>
                                          toggleSubChildAccordion(
                                            activity?.activity_id
                                          )
                                        }
                                      ></i>
                                    )}
                                    {addElipsis(activity?.activityName, 13)}
                                  </div>
                                  <div
                                    className="border p-1"
                                    style={{ width: "20%" }}
                                  >
                                    {activity?.provisional_budget == 0 ||
                                    activity?.provisional_budget == null
                                      ? "-"
                                      : formatNumber(
                                          activity?.provisional_budget /
                                            dividerNumber,
                                          "indian"
                                        )}
                                  </div>
                                  <div
                                    className="border p-1"
                                    style={{ width: "20%" }}
                                  >
                                    {activity?.budget == 0 ||
                                    activity?.budget == null
                                      ? "-"
                                      : formatNumber(
                                          activity?.budget / dividerNumber,
                                          "indian"
                                        )}
                                  </div>
                                  <div
                                    className="border p-1"
                                    style={{ width: "20%" }}
                                  >
                                    {activity?.prev_balance == 0 ||
                                    activity?.prev_balance == null
                                      ? "-"
                                      : formatNumber(
                                          activity?.prev_balance /
                                            dividerNumber,
                                          "indian"
                                        )}
                                  </div>
                                  <div
                                    className="border p-1"
                                    style={{ width: "20%" }}
                                  >
                                    {Number(activity?.budget) +
                                      Number(activity?.prev_balance) ==
                                    0
                                      ? "-"
                                      : formatNumber(
                                          (Number(activity?.budget) +
                                            Number(activity?.prev_balance)) /
                                            dividerNumber,
                                          "indian"
                                        )}
                                  </div>
                                </div>

                                <div
                                  className={`bg-primary ${
                                    tableSubChildAccordian[
                                      activity?.activity_id
                                    ]
                                      ? null
                                      : "d-none"
                                  }`}
                                  style={{
                                    height: tableSubChildAccordian[
                                      activity?.activity_id
                                    ]
                                      ? null
                                      : "0",
                                  }}
                                >
                                  <div className="d-flex justify-content-between text-center">
                                    <div
                                      className="fw-bold border px-1"
                                      style={{ width: "20%" }}
                                    >
                                      Sub Activity
                                    </div>
                                    <div
                                      className="fw-bold border px-1"
                                      style={{ width: "20%" }}
                                    >
                                      Provisional FY{" "}
                                      {fy_list?.map((val, ind) => {
                                        return (
                                          val?.id == storedGlobalDateId &&
                                          val?.year
                                        );
                                      })}
                                    </div>
                                    <div
                                      className="fw-bold border px-1"
                                      style={{ width: "20%" }}
                                    >
                                      Release Fy{" "}
                                      {fy_list?.map((val, ind) => {
                                        return (
                                          val?.id == storedGlobalDateId &&
                                          val?.year
                                        );
                                      })}
                                    </div>
                                    <div
                                      className="fw-bold border px-1"
                                      style={{ width: "20%" }}
                                    >
                                      Previous FY Balance
                                    </div>
                                    <div
                                      className="fw-bold border px-1"
                                      style={{ width: "20%" }}
                                    >
                                      Total Balance
                                    </div>
                                  </div>
                                  {activity?.subActivity?.map((val, ind) => (
                                    <div className="d-flex justify-content-between">
                                      <div
                                        className="border p-1"
                                        style={{ width: "20%" }}
                                      >
                                        {addElipsis(val?.sub_activity_name, 13)}
                                      </div>
                                      <div
                                        className="border p-1"
                                        style={{ width: "20%" }}
                                      >
                                        {val?.provisional_budget == 0 ||
                                        val?.provisional_budget == null
                                          ? "-"
                                          : formatNumber(
                                              val?.provisional_budget /
                                                dividerNumber,
                                              "indian"
                                            )}
                                      </div>
                                      <div
                                        className="border p-1"
                                        style={{ width: "20%" }}
                                      >
                                        {val?.budget == 0 || val?.budget == null
                                          ? "-"
                                          : formatNumber(
                                              val?.budget / dividerNumber,
                                              "indian"
                                            )}
                                      </div>
                                      <div
                                        className="border p-1"
                                        style={{ width: "20%" }}
                                      >
                                        {val?.prev_balance == 0 ||
                                        val?.prev_balance == null
                                          ? "-"
                                          : formatNumber(
                                              val?.prev_balance / dividerNumber,
                                              "indian"
                                            )}
                                      </div>
                                      <div
                                        className="border p-1"
                                        style={{ width: "20%" }}
                                      >
                                        {Number(val?.budget) +
                                          Number(val?.prev_balance) ==
                                        0
                                          ? "-"
                                          : formatNumber(
                                              (Number(val?.budget) +
                                                Number(val?.prev_balance)) /
                                                dividerNumber,
                                              "indian"
                                            )}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ======================card view=========================== */}

          {!listview == true ? null : !schemes.length ? (
            <span>No Data Found</span>
          ) : (
            schemes?.map((val, ind) => (
              <div
                className="bg-white border-Prime-100"
                style={{ borderRadius: "8px" }}
                key={val?.id}
              >
                <div
                  className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden"
                  style={{ borderRadius: "8px 8px 0 0" }}
                >
                  {/* ======================card header================== */}
                  <span
                    className="fs-14px white-space-nowrap overflow-x-hidden"
                    style={{ width: "95%", fontStyle: "italic" }}
                  >
                    {/* =======================card header====================== */}
                    <span
                      className="fs-14px white-space-nowrap overflow-x-hidden "
                      style={{ width: "95%", fontStyle: "italic" }}
                    >
                      {val?.code} {val?.name}
                    </span>
                  </span>

                  <span>
                    <i className="icon-remove_red_eye cursor-pointer"></i>
                  </span>
                </div>

                {/* ================== card body ========================= */}

                <div className="row py-2 px-3">
                  <div className="col d-flex flex-column">
                    <span className="fs-12px text-black-60">
                      Provisional FY{" "}
                      {fy_list?.map((val, ind) => {
                        return val?.id == storedGlobalDateId && val?.year;
                      })}
                    </span>
                    <span className="fs-14px fw-600 ">
                      {val?.total_provisional_budget == 0
                        ? "-"
                        : formatNumber(
                            val.total_provisional_budget / dividerNumber,
                            "indian"
                          )}
                    </span>
                  </div>
                  <div className="col d-flex flex-column">
                    <span className="fs-12px text-black-60">
                      Release FY{" "}
                      {fy_list?.map((val, ind) => {
                        return val?.id == storedGlobalDateId && val?.year;
                      })}
                    </span>
                    <span className="fs-14px fw-600">
                      {val?.total_budget == 0
                        ? "-"
                        : formatNumber(
                            val?.total_budget / dividerNumber,
                            "indian"
                          )}
                    </span>
                  </div>
                  <div className="col d-flex flex-column">
                    <span className="fs-12px text-black-60 d-flex justify-content-between align-items-center">
                      Previous FY Balance
                      <span>
                        <Tooltip
                          title={val?.prevYearBalance}
                          placement="top"
                          arrow
                        >
                          <i className="icon-info cursor-pointer"></i>
                        </Tooltip>
                      </span>
                    </span>
                    <span className="fs-14px fw-600">
                      {val?.prevYearBalance == 0
                        ? "-"
                        : formatNumber(
                            val?.prevYearBalance / dividerNumber,
                            "indian"
                          )}
                    </span>
                  </div>
                  <div className="col d-flex flex-column success-100 bg-success-20 py-1">
                    <span className="fs-12px text-black-60 d-flex justify-content-between align-items-center">
                      Total Balance
                      <Tooltip
                        title={
                          Number(val?.prevYearBalance) +
                          Number(val?.total_budget)
                        }
                        placement="top"
                        arrow
                      >
                        <i className="icon-info cursor-pointer"></i>
                      </Tooltip>
                    </span>
                    <span className="fs-14px fw-600 text-success-100">
                      {val?.prevYearBalance +
                        val?.total_budget +
                        val?.prevYearBalance ==
                      0
                        ? "-"
                        : formatNumber(
                            (val?.prevYearBalance + val?.total_budget) /
                              dividerNumber,
                            "indian"
                          )}
                    </span>
                  </div>
                </div>

                {/* ===================card footer ==================== */}
                <div className="border mx-2"></div>

                {/* =======================buttons ====================== */}

                <div className="p-2 d-flex justify-content-between text-secondary-50 px-4">
                  <button
                    onClick={() => handleButtonClick(val?.id, "1")}
                    className={` ${
                      activeCardChild[val?.id] == 1
                        ? "bg-secondary-20"
                        : "bg-white"
                    }  border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4`}
                  >
                    {activeCardChild[val?.id] == 1 ? (
                      <i className="icon-remove_circle_outline"></i>
                    ) : (
                      <i className="icon-add_circle_outline"></i>
                    )}
                    Sub head
                  </button>

                  {val?.is_activity_active != "0" &&
                    val?.monitoring_level != null && (
                      <>
                        <button
                          onClick={() => handleButtonClick(val.id, "2")}
                          className={`${
                            activeCardChild[val?.id] == 2
                              ? "bg-secondary-20"
                              : "bg-white"
                          } border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                        >
                          {activeCardChild[val?.id] == 2 ? (
                            <i className="icon-remove_circle_outline"></i>
                          ) : (
                            <i className="icon-add_circle_outline"></i>
                          )}
                          Activity
                        </button>
                        <button
                          onClick={() => handleButtonClick(val.id, "3")}
                          className={`${
                            activeCardChild[val?.id] == 3
                              ? "bg-secondary-20"
                              : "bg-white"
                          } border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                        >
                          {activeCardChild[val?.id] == 3 ? (
                            <i className="icon-remove_circle_outline"></i>
                          ) : (
                            <i className="icon-add_circle_outline"></i>
                          )}
                          Sub-Activity
                        </button>
                      </>
                    )}
                </div>

                {/* ===========================contents============================== */}

                {activeCardChild[val?.id] === "1" && (
                  <>
                    <div className="row px-3 m-0">
                      <div
                        className="col d-flex flex-column p-0 py-1"
                        style={{ width: "20%" }}
                      >
                        <span className="fs-12px text-black-60 p-0">
                          Sub Head
                        </span>
                      </div>
                      <div
                        className="col d-flex flex-column p-0 py-1"
                        style={{ width: "20%" }}
                      >
                        <span className="fs-12px text-black-60 p-0">
                          Provisional Budget{" "}
                          {fy_list?.map((val, ind) => {
                            return val?.id == storedGlobalDateId && val?.year;
                          })}
                        </span>
                      </div>
                      <div
                        className="col d-flex flex-column p-0 py-1"
                        style={{ width: "20%" }}
                      >
                        <span className="fs-12px text-black-60 p-0">
                          Release FY{" "}
                          {fy_list?.map((val, ind) => {
                            return val?.id == storedGlobalDateId && val?.year;
                          })}
                        </span>
                      </div>
                      <div
                        className="col d-flex flex-column p-0 py-1"
                        style={{ width: "20%" }}
                      >
                        <span className="fs-12px text-black-60 p-0">
                          Previous Year Balance
                        </span>
                      </div>
                      <div
                        className="col d-flex flex-column p-0 py-1"
                        style={{ width: "20%" }}
                      >
                        <span className="fs-12px text-black-60 p-0">
                          Total Balance
                        </span>
                      </div>
                    </div>

                    {val?.sub_head_list?.map((val, ind) => (
                      <div
                        className="row px-3 m-0"
                        style={{
                          background: ind % 2 === 0 ? "#F8F8F8" : "transparent",
                        }}
                      >
                        <div
                          className="col fs-14px fw-500 p-0 py-1"
                          style={{ width: "20%" }}
                        >
                          {addElipsis(val.name, 17)}
                        </div>
                        <div
                          className="col fs-14px fw-500 p-0 py-1"
                          style={{ width: "20%" }}
                        >
                          {val?.provisional_budget == 0
                            ? "-"
                            : formatNumber(
                                val.provisional_budget / dividerNumber,
                                "indian"
                              )}
                        </div>
                        <div
                          className="col fs-14px fw-500 p-0 py-1"
                          style={{ width: "20%" }}
                        >
                          {val?.budget == 0
                            ? "-"
                            : formatNumber(
                                val.budget / dividerNumber,
                                "indian"
                              )}
                        </div>
                        <div
                          className="col fs-14px fw-500 p-0 py-1"
                          style={{ width: "20%" }}
                        >
                          {val.pervious_year_budget == 0
                            ? "-"
                            : formatNumber(
                                val.pervious_year_budget / dividerNumber,
                                "indian"
                              )}
                        </div>
                        <div
                          className="col fs-14px fw-500 p-0 py-1 text-success-100"
                          style={{ width: "20%" }}
                        >
                          {val.pervious_year_budget + val.budget == 0
                            ? "-"
                            : formatNumber(
                                Number(val.pervious_year_budget) +
                                  Number(val.budget) / dividerNumber,
                                "indian"
                              )}
                        </div>
                      </div>
                    ))}
                  </>
                )}

                {/* =====================activity======================== */}

                <div className="row py-2 px-3">
                  {activeCardChild[val?.id] === "2" && (
                    <div className="d-flex flex-column gap-1">
                      {val?.sub_head_list?.map((val, ind) => {
                        const totalProvisionalBudget =
                          val?.activity_budget?.reduce(
                            (acc, curr) =>
                              acc + (Number(curr?.provisioned) || 0),
                            0
                          );
                        const totalReleasedBudget =
                          val?.activity_budget?.reduce(
                            (acc, curr) => acc + (Number(curr?.released) || 0),
                            0
                          );
                        const totalPrevFyBalance = val?.activity_budget?.reduce(
                          (acc, curr) =>
                            acc + (Number(curr?.prev_balance) || 0),
                          0
                        );

                        return (
                          <Accordion>
                            <Accordion.Item
                              eventKey={val?.id}
                              style={{ borderRadius: "0", border: "0" }}
                            >
                              <Accordion.Header
                                onClick={() => toggleAccordion(val?.id)}
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  position: "relative",
                                  borderRadius: "0",
                                }}
                              >
                                <div className="w-100 d-flex justify-content-between">
                                  <span>{val?.name}</span>
                                  <span
                                    className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                    style={{
                                      height: "13.33px",
                                      width: "13.33px",
                                    }}
                                  >
                                    {activeKeys.includes(val?.id) ? "-" : "+"}
                                  </span>
                                </div>
                              </Accordion.Header>

                              <Accordion.Body className="p-2">
                                <div className="row p-0">
                                  <div className="col">
                                    <p className="fs-12px text-black-60 m-0 py-1">
                                      Activity
                                    </p>
                                  </div>
                                  <div className="col">
                                    <p className="fs-12px text-black-60 m-0 py-1">
                                      Provisional Budget{" "}
                                      {fy_list?.map((val, ind) => {
                                        return (
                                          val?.id == storedGlobalDateId &&
                                          val?.year
                                        );
                                      })}
                                    </p>
                                  </div>
                                  <div className="col">
                                    <p className="fs-12px text-black-60 m-0 py-1">
                                      Released FY{" "}
                                      {fy_list?.map((val, ind) => {
                                        return (
                                          val?.id == storedGlobalDateId &&
                                          val?.year
                                        );
                                      })}
                                    </p>
                                  </div>
                                  <div className="col">
                                    <p className="fs-12px text-black-60 m-0 py-1">
                                      Previous FY Balance
                                    </p>
                                  </div>
                                  <div className="col">
                                    <p className="fs-12px text-black-60 m-0 py-1">
                                      Total
                                    </p>
                                  </div>
                                </div>
                                {/* {(() => { 
                                  // Filter and sum budgets for "(5)- वेतन"
                                  // const salaryActivities =
                                  //   val?.activity_budget?.filter(
                                  //     (item) => item?.activity === "(5)- वेतन"
                                  //   );

                                  // const summedSalaryData =
                                  //   salaryActivities?.reduce(
                                  //     (acc, curr) => ({
                                  //       provisional_budget:
                                  //         Number(acc.provisional_budget) +
                                  //         (Number(curr?.provisional_budget) ||
                                  //           0),
                                  //       budget:
                                  //         Number(acc.budget) +
                                  //         (Number(curr?.budget) || 0),
                                  //       prev_balance:
                                  //         Number(acc.prev_balance) +
                                  //         (Number(curr?.prev_balance) || 0),
                                  //     }),
                                  //     {
                                  //       provisional_budget: 0,
                                  //       budget: 0,
                                  //       prev_balance: 0,
                                  //     }
                                  //   );

                                  // Creating a new dataset with summed salary data
                                  // let modifiedData =
                                  //   val?.activity_budget?.filter(
                                  //     (item) => item?.activity !== "(5)- वेतन"
                                  //   );

                                  // if (salaryActivities.length > 0) {
                                  //   modifiedData = [
                                  //     {
                                  //       activity: "(5)- वेतन",
                                  //       provisional_budget:
                                  //         summedSalaryData.provisional_budget,
                                  //       budget: summedSalaryData.budget,
                                  //       prev_balance:
                                  //         summedSalaryData.prev_balance,
                                  //     },
                                  //     ...modifiedData, // Add remaining activities
                                  //   ];
                                  // }

                                  // Mapping through modified data
                                  */}
                                  { 
                                    val?.activity_budget?.map((item, ind) => (
                                      <div
                                        className="row p-0"
                                        key={ind}
                                        style={{
                                          background:
                                            ind % 2 === 0
                                              ? "#F8F8F8"
                                              : "transparent",
                                        }}
                                      >
                                      <div className="col">
                                        <p className="fs-14px text-black fw-500 m-0 py-1">
                                          {addElipsis(item?.activityName, 17)}
                                        </p>
                                      </div>
                                      <div className="col">
                                        <p className="fs-14px text-black fw-500 m-0 py-1">
                                          {item?.provisioned === 0
                                            ? "-"
                                            : formatNumber(
                                                item?.provisioned /
                                                  dividerNumber,
                                                "indian"
                                              )}
                                        </p>
                                      </div>
                                      <div className="col">
                                        <p className="fs-14px text-black fw-500 m-0 py-1">
                                          {item?.released === 0
                                            ? "-"
                                            : formatNumber(
                                                item?.released / dividerNumber,
                                                "indian"
                                              )}
                                        </p>
                                      </div>
                                      <div className="col">
                                        <p className="fs-14px text-black fw-500 m-0 py-1">
                                          {item?.prev_balance == 0
                                            ? "-"
                                            : formatNumber(
                                                Number(item?.prev_balance) /
                                                  dividerNumber,
                                                "indian"
                                              )}
                                          {/* <span>number {item?.prev_balance}</span> */}
                                        </p>
                                      </div>
                                      <div className="col text-success-100">
                                        <p className="fs-14px fw-500 m-0 py-1">
                                          {Number(item?.released) +
                                            Number(item?.prev_balance) ==
                                          0
                                            ? "-"
                                            : formatNumber(
                                                (Number(item?.released) +
                                                  Number(item?.prev_balance)) /
                                                  dividerNumber,
                                                "indian"
                                              )}
                                        </p>
                                      </div>
                                    </div>
                                  ))
                                  }

                                <div className="row p-0 bg-info-20">
                                  <div className="col">
                                    <p className="fs-14px text-info fw-500 py-1 m-0">
                                      Total
                                    </p>
                                  </div>
                                  <div className="col">
                                    <p className="fs-14px text-black fw-500 py-1 m-0">
                                      {totalProvisionalBudget == 0
                                        ? "-"
                                        : formatNumber(
                                            totalProvisionalBudget /
                                              dividerNumber,
                                            "indian"
                                          )}
                                    </p>
                                  </div>
                                  <div className="col">
                                    <p className="fs-14px text-black fw-500 py-1 m-0">
                                      {totalReleasedBudget == 0
                                        ? "-"
                                        : formatNumber(
                                            totalReleasedBudget / dividerNumber,
                                            "indian"
                                          )}
                                    </p>
                                  </div>
                                  <div className="col">
                                    <p className="fs-14px text-black fw-500 py-1 m-0">
                                      {totalPrevFyBalance == 0
                                        ? "-"
                                        : formatNumber(
                                            totalPrevFyBalance / dividerNumber,
                                            "indian"
                                          )}
                                    </p>
                                  </div>
                                  <div className="col text-success-100">
                                    <p className="fs-14px fw-500 py-1 m-0">
                                      {totalReleasedBudget +
                                        totalPrevFyBalance ==
                                      0
                                        ? "-"
                                        : formatNumber(
                                            (totalReleasedBudget +
                                              totalPrevFyBalance) /
                                              dividerNumber,
                                            "indian"
                                          )}
                                    </p>
                                  </div>
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        );
                      })}
                    </div>
                  )}
                </div>

                {/* ===================sub activity============= */}

                <div className="row pb-2 px-3">
                  {activeCardChild[val?.id] === "3" && (
                    <div className="d-flex flex-column gap-1">
                      {val?.sub_head_list?.map((val, ind) =>
                        val?.activity_budget?.map((sub, ind) => {
                          const totalProvisionalBudget =
                            sub?.subActivity?.reduce(
                              (acc, curr) =>
                                acc + (Number(curr?.provisioned) || 0),
                              0
                            );
                          const totalReleasedBudget = sub?.subActivity?.reduce(
                            (acc, curr) => acc + (Number(curr?.released) || 0),
                            0
                          );
                          const totalPrevFyBalance = sub?.subActivity?.reduce(
                            (acc, curr) =>
                              acc + (Number(curr?.prev_balance) || 0),
                            0
                          );

                          return (
                            <Accordion key={sub?.activity_id || ind}>
                              <Accordion.Item
                                eventKey={val?.id + ind}
                                style={{ borderRadius: "0", border: "0" }}
                              >
                                <Accordion.Header
                                  onClick={() => toggleAccordion(val?.id + ind)}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    position: "relative",
                                    borderRadius: "0",
                                  }}
                                >
                                  <div className="w-100 d-flex justify-content-between">
                                    <span>
                                      {val?.name + " | " + sub?.activityName}{" "}
                                      {ind + 1}
                                    </span>
                                    <span
                                      className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                      style={{
                                        height: "13.33px",
                                        width: "13.33px",
                                      }}
                                    >
                                      {activeKeys.includes(val?.id + ind)
                                        ? "-"
                                        : "+"}
                                    </span>
                                  </div>
                                </Accordion.Header>

                                <Accordion.Body className="p-2">
                                  <div className="row p-0">
                                    <div className="col">
                                      <p className="fs-12px text-black-60 m-0 py-1">
                                        Activity
                                      </p>
                                    </div>
                                    <div className="col">
                                      <p className="fs-12px text-black-60 m-0 py-1">
                                        Provisional Budget{" "}
                                        {fy_list?.map((val, ind) => {
                                          return (
                                            val?.id == storedGlobalDateId &&
                                            val?.year
                                          );
                                        })}
                                      </p>
                                    </div>
                                    <div className="col">
                                      <p className="fs-12px text-black-60 m-0 py-1">
                                        Released FY{" "}
                                        {fy_list?.map((val, ind) => {
                                          return (
                                            val?.id == storedGlobalDateId &&
                                            val?.year
                                          );
                                        })}
                                      </p>
                                    </div>
                                    <div className="col">
                                      <p className="fs-12px text-black-60 m-0 py-1">
                                        Previous FY Balance
                                      </p>
                                    </div>
                                    <div className="col">
                                      <p className="fs-12px text-black-60 m-0 py-1">
                                        Total
                                      </p>
                                    </div>
                                  </div>
                                  {sub.subActivity?.map((val, ind) => (
                                    <div className="row p-0">
                                      <div className="col">
                                        <p className="fs-14px text-black fw-500 m-0 py-1">
                                          {val?.sub_activity_name}
                                        </p>
                                      </div>
                                      <div className="col">
                                        <p className="fs-14px text-black fw-500 m-0 py-1">
                                          {val?.provisioned === 0
                                            ? "-"
                                            : formatNumber(
                                                val?.provisioned /
                                                  dividerNumber,
                                                "indian"
                                              )}
                                        </p>
                                      </div>
                                      <div className="col">
                                        <p className="fs-14px text-black fw-500 m-0 py-1">
                                          {val?.released === 0
                                            ? "-"
                                            : formatNumber(
                                                val?.released / dividerNumber,
                                                "indian"
                                              )}
                                        </p>
                                      </div>
                                      <div className="col">
                                        <p className="fs-14px text-black fw-500 m-0 py-1">
                                          {val?.prev_balance === 0
                                            ? "-"
                                            : formatNumber(
                                                val?.prev_balance /
                                                  dividerNumber,
                                                "indian"
                                              )}
                                        </p>
                                      </div>
                                      <div className="col text-success-100">
                                        <p className="fs-14px fw-500 m-0 py-1">
                                          {Number(val?.released) +
                                            Number(val?.prev_balance) ==
                                          0
                                            ? "-"
                                            : formatNumber(
                                                (Number(val?.released) +
                                                  Number(val?.prev_balance)) /
                                                  dividerNumber,
                                                "indian"
                                              )}
                                        </p>
                                      </div>
                                    </div>
                                  ))}


                                  {(() => {

                                    const totals = sub.subActivity?.reduce(
                                      (acc, curr) => {
                                        acc.budget += Number(curr.released || 0);
                                        acc.provisional_budget += Number(curr.provisioned || 0);
                                        acc.prev += Number(curr.prev_balance || 0);
                                        return acc;
                                      },
                                      { budget: 0, provisional_budget: 0, prev: 0 }
                                    );

                                    return (
                                      <div className="row p-0 bg-info-20">
                                        <div className="col">
                                          <p className="fs-14px text-info fw-500 py-1 m-0">
                                            Total
                                          </p>
                                        </div>
                                        <div className="col">
                                          <p className="fs-14px text-black fw-500 py-1 m-0">
                                            {formatNumber(totals.provisional_budget / dividerNumber, "indian")}
                                          </p>
                                        </div>
                                        <div className="col">
                                          <p className="fs-14px text-black fw-500 py-1 m-0">
                                            {formatNumber(totals.budget / dividerNumber, "indian")}
                                          </p>
                                        </div>
                                        <div className="col">
                                          <p className="fs-14px text-black fw-500 py-1 m-0">
                                                {
                                                formatNumber(totals.prev / dividerNumber, "indian")
                                                }
                                          </p>
                                        </div>
                                        <div className="col text-success-100">
                                          <p className="fs-14px fw-500 py-1 m-0">
                                            {formatNumber((totals.budget + totals.prev) / dividerNumber, "indian")}
                                          </p>
                                        </div>
                                      </div>
                                    );
                                  })()}

                                  
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          );
                        })
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default SchemeBudgetOverlay;
